import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Panel from '../../components/Panel/Panel';
import JPanel from '../../components/UI/JPanel';
import { JButton } from '../../components/UI/JButton';
import { cancelFromServer, fromServer, toServer } from '../../util/ServerSocket';
import '../../components/Notice/GameNotice.css';
import './RenameCard.css';

export function RenameCard() {
  const [uid, setUid] = useState<string | null>(null);
  useEffect(() => {
    const prompt = (data: { uid: string }) => { if (typeof data?.uid === 'string') setUid(data.uid); };
    fromServer('renameCardPrompt', prompt);
    return () => { cancelFromServer('renameCardPrompt', prompt); };
  }, []);
  return uid ? <RenameCardDialog key={uid} uid={uid} onClose={() => setUid(null)} /> : null;
}

export function RenameCardDialog({ uid, onClose }: { uid: string; onClose: () => void }) {
  const [name, setName] = useState(''), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const pending = useRef(false), mounted = useRef(true), timer = useRef<number>();
  const request = useRef<{ uid: string; name: string; requestId: string }>();
  useEffect(() => () => { mounted.current = false; window.clearTimeout(timer.current); }, []);
  function confirm() {
    if (pending.current) return;
    const value = name.trim().normalize('NFC');
    if (Array.from(value).length < 3 || Array.from(value).length > 30) { setError('ชื่อตัวละครต้องยาว 3–30 ตัวอักษร'); return; }
    if (!request.current || request.current.name !== value) request.current = { uid, name: value, requestId: `${Date.now()}-${Math.random()}` };
    pending.current = true; setBusy(true); setError('');
    timer.current = window.setTimeout(() => {
      pending.current = false; setBusy(false); setError('เซิร์ฟเวอร์ไม่ตอบสนอง กด Confirm เพื่อตรวจสอบอีกครั้ง');
    }, 10000);
    toServer('renameCharacter', request.current, (reply?: { success?: boolean; error?: string }) => {
      if (!mounted.current) return;
      window.clearTimeout(timer.current); pending.current = false; setBusy(false);
      if (reply?.success) onClose();
      else { request.current = undefined; setError(reply?.error ?? 'เปลี่ยนชื่อไม่สำเร็จ กรุณาลองใหม่'); }
    });
  }
  return createPortal(<div className="game-notice-layer" role="dialog" aria-modal="true" aria-label="Re-name Card">
    <Panel name="Re-name Card" moveable={false} style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 30041 }}>
      <JPanel size={{ width: 294, height: 116 }}>
        <input className="rename-card-input" aria-label="ชื่อตัวละครใหม่" placeholder="ชื่อตัวละครใหม่" value={name} maxLength={60} autoFocus disabled={busy}
          onChange={event => { setName(event.target.value); setError(''); }}
          onKeyDown={event => { if (event.key === 'Enter') confirm(); if (event.key === 'Escape' && !busy) onClose(); }} />
        {error && <div className="rename-card-error" role="alert">{error}</div>}
        <JButton size={{ width: 78, height: 20 }} position={{ x: 62, y: 80 }} text="Confirm" translate={false} disabled={busy} onClick={confirm} />
        <JButton size={{ width: 78, height: 20 }} position={{ x: 154, y: 80 }} text="Cancel" translate={false} disabled={busy} onClick={onClose} />
      </JPanel>
    </Panel>
  </div>, document.body);
}
